module.exports = __webpack_public_path__ + "img/ziti_advantage.ee055945.png";